import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ProductBuilder } from '../../models/builders/product-builder';
import { ComplementBuilder } from '../../models/builders/complement-builder';
import { ProductsRequestInterface } from '../../models/request/products-request.interface';
import { ProductTypeBuilder } from '../../models/builders/product-type.builder';
import { Product } from '../../models/product';

const createProductBody = (product: Product) => (
  {
    code: product.code,
    name: product.name,
    price: product.price,
    weight: product.weight,
    description: product.description,
    needSerialNumber: product.needSerialNumber,
    productTypeHash: product.productType,
    brandHash: product.brand,
  }
);

@Injectable()
export class ProductApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}products`;
  }

  getProduct(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
     .pipe(
       map(ProductBuilder.fromJson)
    );
  }

  getProducts() {
    return this.httpClient.get(this.apiUrl).pipe(map(ProductBuilder.fromJsonList));
  }

  getComplements(productHash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ productHash }/complements`).pipe(map(ComplementBuilder.fromJsonList));
  }

  createProduct(product: Product) {
    return this.httpClient.post(`${this.apiUrl}`, createProductBody(product)).pipe(
      map(ProductBuilder.fromJson)
    );
  }

  updateProduct(product: Product) {
    return this.httpClient.put(`${ this.apiUrl }/${ product.hash }`, createProductBody(product));
  }

  deleteProduct(productHash: string) {
    return this.httpClient.delete(`${ this.apiUrl }/${ productHash }`);
  }

  getFilteredProducts(request: ProductsRequestInterface)  {
    let params = new HttpParams();
    params = params.append('page', request.page.toString())
                   .append('itemsPerPage', request.itemsPerPage.toString())
                   .append('sortField', request.sortField)
                   .append('reverse', (!!request.reverse).toString());
    if (request.code) {
      params = params.append('code', request.code);
    }
    if (request.name) {
      params = params.append('name', request.name);
    }

    return this.httpClient.get(`${this.apiUrl}/filter`, { params: params })
      .pipe(
        map(this.mapData)
      );
  }

  getProductTypes() {
    return this.httpClient.get(`${this.apiUrl}/product-types`).pipe(map(ProductTypeBuilder.fromJsonList));
  }

  private mapData = (data) => {
    data.products = ProductBuilder.fromJsonList(data.products);
    return data;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/product-api.service.ts